import React, { useState } from 'react';
import { Row, Col, Button, Select, Space, DatePicker, Input } from 'antd';
import { ClearOutlined, SearchOutlined } from '@ant-design/icons';
import { convertLocaltimeToUTC } from '@utils/utils';

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterTable = ({ dataFilter, onChange, setFlagSearch, flagSearch, users }) => {
  const tmpUsers = users || [];
  const [dateRange, setDateRange] = useState([]);
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState(null);

  const userOptions = tmpUsers.map((d) => (
    <Option key={d.id} value={String(d.id)}>
      {d.username}
    </Option>
  ));

  const onChangeDateRange = (dates, dateStrings) => {
    setDateRange(dates);
    const from_date = convertLocaltimeToUTC(dateStrings[0], '00:00:00.000');
    const to_date = convertLocaltimeToUTC(dateStrings[1], '23:59:59.999');
    onChange({
      ...dataFilter,
      from_date,
      to_date
    });
  };

  const onChangeSearchUser = (e) => {
    setUser(e.target.value);
    onChange({
      ...dataFilter,
      search_username: e.target.value
    });
  };

  const onChangeStatus = (value) => {
    setStatus(value);
    onChange({
      ...dataFilter,
      status: value
    });
  };

  const handleSearchTable = () => {
    setFlagSearch(!flagSearch);
  };

  const clearFilter = () => {
    onChange({});
    setUser(null);
    setStatus(null);
    setFlagSearch(!flagSearch);
  };

  const statusOpts = [
    { label: 'Đang hoạt động', value: true },
    { label: 'Ngừng hoạt động', value: false }
  ];

  return (
    <div style={{ width: '100%' }}>
      <Row gutter={[16, 16]} style={{ marginBottom: '15px' }}>
        <Col xs={24} sm={12} md={8}>
          <Input
            value={user}
            onChange={onChangeSearchUser}
            onPressEnter={handleSearchTable}
            placeholder="Tên người dùng"
            style={{ height: '36px' }}
          />
        </Col>
        <Col xs={24} sm={12} md={8}>
          <Select
            value={status}
            onChange={onChangeStatus}
            placeholder="Trạng thái"
            style={{ width: '100%', height: '36px' }}>
            {statusOpts.map((opt) => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button
              style={{ border: 'none', backgroundColor: 'var(--surface-3)' }}
              icon={<ClearOutlined />}
              onClick={clearFilter}>
              Huỷ
            </Button>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={handleSearchTable}
              style={{
                backgroundColor: '#0284c7',
                borderColor: '#0284c7'
              }}>
              Lọc
            </Button>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default FilterTable;
